import { AccountFilterRequest } from "callable-data-objects";
import Account from "callable-data-objects/dist/models/account/Account";
import Page from "callable-data-objects/dist/services/Page";
import AccountList from "Components/Account/AccountList";
import AccountPagination from "Components/Account/AccountPagination";
import MenuSearch from "Components/Shared/MenuSearch";
import useCheckRole from "Hooks/APICheckRole";
import React from "react";
import { Breadcrumb, Button, Container, Icon, Menu } from "semantic-ui-react";

type AccountListHolderProps = {
  search: Function;
  select: Function;
  createAccount: Function;
  accounts: Page<Account>;
  filter: AccountFilterRequest;
  setFilter: React.Dispatch<React.SetStateAction<AccountFilterRequest>>;
};

const AccountListHolder = ({
  search,
  select,
  createAccount,
  accounts,
  setFilter,
  filter,
}: AccountListHolderProps) => {
  const { hasRole, roles } = useCheckRole();

  return (
    <Container fluid className='listContainer'>
      <Menu stackable>
        <Menu.Item header>
          <Breadcrumb>
            <Breadcrumb.Section>Accounts</Breadcrumb.Section>
          </Breadcrumb>
        </Menu.Item>
        <Menu.Menu className='searchMenu'>
          <MenuSearch onSearch={search} value={filter.text} />
        </Menu.Menu>
        {hasRole(roles.account.roles.create) && (
          <Menu.Menu position='right'>
            <Menu.Item>
              <Button
                primary
                style={{ width: "120px" }}
                onClick={() => createAccount()}
              >
                <Icon name='plus' />
                Create
              </Button>
            </Menu.Item>
          </Menu.Menu>
        )}
      </Menu>
      <AccountList accounts={accounts} select={select} />
      <AccountPagination
        accounts={accounts}
        filter={filter}
        setFilter={setFilter}
      />
    </Container>
  );
};

export default AccountListHolder;
